import * as React from 'react';
import * as styles from './styles.css';

import { UIHeading4, UIText1 } from '@cian/ui-kit';

export const CulturalHeritage: React.FC = () => {
  return (
    <div data-testid="CulturalHeritage">
      <div className={styles['title']}>
        <UIHeading4>Можно</UIHeading4>
      </div>
      <div className={styles['text']}>
        <UIText1>
          Делать поддерживающий ремонт, если он не затрагивает предмет охраны. Чаще всего это уникальная фасадная,
          декоративная или интерьерная деталь — например, лепнина на потолке или перила в подъезде.
        </UIText1>
      </div>
      <div className={styles['title']}>
        <UIHeading4>Нужно согласовать</UIHeading4>
      </div>
      <div className={styles['text']}>
        <UIText1>
          Проведение переустройства и перепланировки. Разрешение выдают органы охраны культурного наследия, а процесс
          зависит от того, затрагивается ли предмет охраны при ремонте.
        </UIText1>
      </div>
      <div className={styles['title']}>
        <UIHeading4>Точно нельзя</UIHeading4>
      </div>
      <div className={styles['text']}>
        <UIText1>
          Радикально менять внешний вид здания: устанавливать кондиционеры на фасадах, заменять деревянные окна
          на пластиковые, остеклять балконы и возводить лоджии. А ещё использовать помещение как склад или производство.
        </UIText1>
      </div>
    </div>
  );
};

CulturalHeritage.displayName = 'CulturalHeritage';
